var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Prop, Component, Emit } from 'vue-property-decorator';
import { useStore } from 'vuex-simple';
import PromptDialog from '@/components/shared/PromptDialog.vue';
var PromptDialogMixin = /** @class */ (function (_super) {
    __extends(PromptDialogMixin, _super);
    function PromptDialogMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = useStore(_this.$store);
        return _this;
    }
    Object.defineProperty(PromptDialogMixin.prototype, "loading", {
        get: function () {
            return this.store.loading;
        },
        set: function (loading) {
            this.store.setLoading(loading);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromptDialogMixin.prototype, "selectedItem", {
        /**
         * Item that has been selected
         */
        get: function () {
            return this.store.items.selectedItem;
        },
        /**
         * Set the currently selected item
         */
        set: function (item) {
            this.store.items.setSelectedItem(item);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromptDialogMixin.prototype, "selectedItemCanBeDeleted", {
        /**
         * If the selected item can be deleted
         */
        get: function () {
            return this.store.dialog.itemCanBeDeleted;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromptDialogMixin.prototype, "selectedItemCanBeDeletedMessage", {
        /**
         * Message for if the item can not be deleted
         */
        get: function () {
            return this.store.dialog.itemCanBeDeletedMessage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromptDialogMixin.prototype, "selectedItemHasWarning", {
        /**
         * If the selected item can be deleted with a warning
         */
        get: function () {
            return this.store.dialog.itemHasWarning;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromptDialogMixin.prototype, "selectedItemHasWarningMessage", {
        /**
         * Message for if the selected item can be deleted with a warning
         */
        get: function () {
            return this.store.dialog.itemHasWarningMessage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromptDialogMixin.prototype, "selectedItemCanBeRestored", {
        /**
         * If the selected item can be restored
         */
        get: function () {
            return this.store.dialog.itemCanBeRestored;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PromptDialogMixin.prototype, "restoreDialogVisible", {
        /**
         * If the restore dialog is visible
         */
        get: function () {
            return this.store.dialog.restoreDialogVisible;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Close the restore prompt dialog
     */
    PromptDialogMixin.prototype.closeRestoreDialog = function () {
        this.store.dialog.closeRestoreDialog();
    };
    Object.defineProperty(PromptDialogMixin.prototype, "deleteDialogVisible", {
        /**
         * If the delete dialog is visible
         */
        get: function () {
            return this.store.dialog.deleteDialogVisible;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Close the delete prompt dialog
     */
    PromptDialogMixin.prototype.closeDeleteDialog = function () {
        this.store.dialog.closeDeleteDialog();
    };
    Object.defineProperty(PromptDialogMixin.prototype, "dialogVisible", {
        /**
         * If the dialog is visible
         */
        get: function () {
            return this.store.dialog.dialogVisible;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Close the prompt dialog
     */
    PromptDialogMixin.prototype.closeDialog = function () {
        this.store.dialog.closeDialog();
    };
    Object.defineProperty(PromptDialogMixin.prototype, "mode", {
        /**
         * Get the mode of the prompt dialog
         */
        get: function () {
            return this.store.dialog.mode;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Emits when the cancel button is clicked
     */
    PromptDialogMixin.prototype.cancelled = function () { };
    /**
     * Emits when the confirm button is clicked
     */
    PromptDialogMixin.prototype.confirmed = function () { };
    __decorate([
        Prop({ type: Boolean, required: false }),
        __metadata("design:type", Boolean)
    ], PromptDialogMixin.prototype, "value", void 0);
    __decorate([
        Prop({ type: String, required: false, default: '400px' }),
        __metadata("design:type", String)
    ], PromptDialogMixin.prototype, "maxWidth", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: true }),
        __metadata("design:type", Boolean)
    ], PromptDialogMixin.prototype, "persistent", void 0);
    __decorate([
        Prop({ type: String, required: false, default: 'secondary' }),
        __metadata("design:type", String)
    ], PromptDialogMixin.prototype, "cancelButtonColor", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: true }),
        __metadata("design:type", Boolean)
    ], PromptDialogMixin.prototype, "cancelButtonDark", void 0);
    __decorate([
        Prop({ type: String, required: false, default: 'primary' }),
        __metadata("design:type", String)
    ], PromptDialogMixin.prototype, "confirmButtonColor", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: true }),
        __metadata("design:type", Boolean)
    ], PromptDialogMixin.prototype, "confirmButtonDark", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], PromptDialogMixin.prototype, "confirmButtonHidden", void 0);
    __decorate([
        Emit('cancelled'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PromptDialogMixin.prototype, "cancelled", null);
    __decorate([
        Emit('confirmed'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], PromptDialogMixin.prototype, "confirmed", null);
    PromptDialogMixin = __decorate([
        Component({
            components: {
                'prompt-dialog': PromptDialog,
            },
        })
    ], PromptDialogMixin);
    return PromptDialogMixin;
}(Vue));
export default PromptDialogMixin;
